(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-pool-sizes"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){if(!event.target.matches('[data-hc-pool-size]'))return;const region=event.target.closest('.hc-spa-preview-copy,.hc-spa-summary');if(!region)return;region.querySelectorAll('[data-hc-product]').forEach(function(link){const base=link.dataset.hcBaseProduct||(link.dataset.hcBaseProduct=link.dataset.hcProduct);link.dataset.hcProduct=base+(event.target.value?' — '+event.target.value:'');});});
  } catch(e) { console.error(e); }
})();

})();
